import jwtAuthAxios from "./auth/jwtAuth";

// Panel de configuracion de Relbase por cliente. Ver hermes-backend app/controllers/api/v1/relbase_config_controller.rb.
const relbaseConfigServices = {};

relbaseConfigServices.show = async (id) => (await jwtAuthAxios.get(`/relbase_config/${id}`, { timeout: 30000 })).data;

relbaseConfigServices.update = async (id, config) => (await jwtAuthAxios.put(`/relbase_config/${id}`, { config }, { timeout: 30000 })).data;

// Encola la vista previa; el resultado llega en show() bajo `preview` cuando el job termina.
relbaseConfigServices.preview = async (id, { sinceDays, config }) =>
    (await jwtAuthAxios.post(`/relbase_config/${id}/preview`, { since_days: sinceDays, config }, { timeout: 30000 })).data;

relbaseConfigServices.initialSync = async (id, sinceDays) =>
    (await jwtAuthAxios.post(`/relbase_config/${id}/initial_sync`, { since_days: sinceDays }, { timeout: 30000 })).data;

export default relbaseConfigServices;
